// src/BannerManager.js
import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";
import "./BannerManager.css";

export default function BannerManager() {
  const [banners, setBanners] = useState([]);
  const [newUrl, setNewUrl] = useState("");

  useEffect(() => {
    async function load() {
      const snap = await getDocs(collection(db, "banners"));
      setBanners(snap.docs.map(d => ({ id: d.id, url: d.data().imageUrl })));
    }
    load();
  }, []);

  const handleAdd = async () => {
    if (!newUrl.trim()) return;
    const ref = await addDoc(collection(db, "banners"), { imageUrl: newUrl });
    setBanners(prev => [...prev, { id: ref.id, url: newUrl }]);
    setNewUrl("");
  };

  const handleDelete = async id => {
    await deleteDoc(doc(db, "banners", id));
    setBanners(prev => prev.filter(b => b.id !== id));
  };

  return (
    <div className="banner-manager">
      <h2>Banner Manager</h2>
      <div className="add-banner">
        <input
          type="url"
          placeholder="Image URL"
          value={newUrl}
          onChange={e => setNewUrl(e.target.value)}
        />
        <button onClick={handleAdd}>Add Banner</button>
      </div>
      <div className="banner-list">
        {banners.length === 0 && <p>No banners found.</p>}
        {banners.map(b => (
          <div className="banner-item" key={b.id}>
          <img
  src={b.url}
  alt="Banner"
  onError={e => {
    e.target.onerror = null;
    e.target.src = "https://via.placeholder.com/180x120?text=No+Image";
  }}
/>

            <button onClick={() => handleDelete(b.id)}>Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
}
